import GeneralSettingsContent from "./GeneralSettingsContent";

export default GeneralSettingsContent;
